export default class Auth
{
    checkAuth(api, success, error)
    {
        api.send({
            controller: "Authentication",
            action: "CheckAuth",
            method: "GET",
            success: (result) => {
                if (result.success) {
                    success(result);
                }
                else
                {
                    error(result);
                }
            },
            error: (err) => {
                error(err);
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/general/auth.js